<template>
    <div class="col-sm-9 center pv3 pv4-ns">
        <!-- suggested card -->
        <CardShell>
            <StepProgress :currentStep="step" :totalSteps="10"/>
            <ListHeader
                class="ph3 ph4-ns"
                :image="image"
                :imageLabel="imageLabel" :heading="heading"
            />
            <slot></slot>
        </CardShell>
    </div>
        
</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import StepProgress from '@/components/controls/StepProgress.vue';
import ListHeader from '@/components/list/shared/ListHeader.vue';

export default {
    components: {
        CardShell,
        StepProgress,
        ListHeader
    },
    props: {
        image: {
            type: String
        },
        imageLabel: {
            type: String
        },
        heading: {
            type: String
        },
        step: {
            type: Number
        }
    }
};
</script>
